import { Options, Vue } from 'vue-class-component'
import LeftSideBar from '../LeftSideBar/index.vue'
import { Posts } from '@/services/PostsDataService'
@Options({
  components: {
    LeftSideBar
  }
})
export default class Kontakt extends Vue {
  contactDetails: any = ''
  public async getContactDetails () {
    try {
      const res = await Posts.PostsDataService.getBySlug('Kontakt')
      console.log(res, 'res data ==>')
      this.contactDetails = res.data
    } catch (error) {
      console.log(error)
    }
  }

  mounted (): void {
    this.getContactDetails()
  }
}
